<template>
    <div class="alert-container">
        <v-alert
            :value="showAlert"
            class="custom-size"
            transition="scale-transition"
            :type="type"
        >
            {{ message }}
        </v-alert>
    </div>
</template>

<script>
    export default {
        props: {
            showAlert: {
                type: Boolean,
                default: false
            },
            message: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: 'error'
            }
        }
    }
</script>

<style scoped>

.alert-container {
    display: flex;
    justify-content: center;
    margin: 25px auto;
}

.custom-size {
    margin: 0 auto;
    text-align: center;
}

</style>
